import request from '@/utils/request';
import { ResCode, PagingReq, Meter, PagingResData, MeterFault, Leakage, CommonResponse, MeterType, SimplifyMeter, RsNetwork, ModelConfig } from './baseDefine';
export interface GetMessageReq extends PagingReq {
    meterTypeID: number;
    meterID: string;
    meterTypeName: string;
    searchCompanyID: number;
    userNO: string;
}
export interface MeterTypeReq {
    queryAll: boolean;
}
export interface GetDataReq {
    startTime: number;
    endTime: number;
    meterID: string;
    types: number[];
}

export interface GetExternalDeviceDataReq {
    startTime: number;
    endTime: number;
    meterID: string;
    modelIndex: number[];
}

export interface GetExternalDeviceDataRes {
    code: ResCode;
    msg: string;
    data: GetExternalDeviceDataResData;
}

export interface GetExternalDeviceDataResData {
    externalDeviceModelDatas: ExternalDeviceModelData[];
}

export interface ExternalDeviceModelData {
    modelIndex: number
    datas: string[];
}
export interface DeleteMeterReq {
    deleteType: number;
    meterID: string;
}
export interface MeterTypeList {
    code: ResCode;
    msg: string;
    data: MeterTypesRes;
}
export interface MeterTypesRes {
    meterTypes: MeterTypes;
}

export interface MeterTypes {
    list: MeterType[];
}

// 获取子级设备的请求字段
export interface ChildMeterReq {
    meterID: number;
}
// 获取表的请求
export interface GetMetersReq extends PagingReq {
    meter: Meter;
}
export interface GetMeterDetailReq {
    id: number;
}
export interface GetMeterRes {
    code: ResCode;
    msg: string;
    data: GetMeterResData;
}
export interface GetMeterResData {
    meter: Meter
}
// 模糊搜索设备的请求字段
export interface QueryMeterReq {
    query: string;
}
export interface MeterList {
    code: ResCode;
    msg: string;
    data: MeterlistData;
}
export interface SetMeterParentReq {
    baseMeterID: number;
    parentMeterID: number;
    batchMeterIDs: number[];
    baseMeterIDStr: string;
}
export interface BatchBindUserReq {
    UserNO: string;
    batchMeterIDs: number[];
}

export interface BatchBindMeterCostReq {
    type: number;
    date: string;
    meterCostName: string;
    batchMeterIDs: number[];
}
/**
 * 发送硬件数据的请求
 *
 * @export
 * @interface SendDataReq
 */
export interface SendDataReq {
    meterIDs: SimplifyMeter[];
    params: string;
    dataType: number;
    bRs485:boolean;
}

export interface ReCalculateUsageReq {
    meterID: string;
}


export interface SearchMeterReq {
    meterID: string;
    typeName: string;
    parentMeterID: string;
    ownUser: string;
}
/**
 * /api/meter/meters 的返回
 *
 * @export
 * @interface MeterlistData
 */
export interface MeterlistData {
    meters: MetersData;
}
export interface MetersData {
    list: Meter[];
    curPage: number;
    totalPage: number;
    totalCount: number;
    nextPage: number;
}

export interface MeterFalutList {
    code: ResCode;
    msg: string;
    data: MeterFaultsRes;
}
export interface MeterFaultsRes {
    meterFaults: MeterFalutsData;
}
export interface MeterFalutsData extends PagingResData {
    list: MeterFault[];
}

export interface LeakageList {
    code: ResCode;
    msg: string;
    data: LeakagesRes;
}
export interface LeakagesRes {
    leakageData: LeakageData;
}
export interface LeakageData extends PagingResData {
    list: Leakage[]
}
export interface GetDatasRes {
    code: ResCode;
    msg: string;
    data: GetDataData;
}

export interface GetDataData {
    datas: string[];
}

export interface GetPowerConditionerDataRes extends CommonResponse {
    data: GetPowerConditionerDataResData;
}
export interface GetPowerConditionerDataResData extends CommonResponse {
    isReadCommandExsit: boolean;
    datas: PowerConditioner[];
}
export interface GetPowerConditionerDataReq {
    model: number;
    meterID: string;
}
export interface PowerConditioner {
    meterID: string;
    unit: string;
    value: string;
    typeAndAddress: string;
    timestamp: number;
    byteNum: number;
    respondCode: string;
    time: string;
    modelType: number;
    index: string;
}

export interface GetModelConfigsReq {
}

export interface GetModelConfigsRes extends CommonResponse {
    data: GetModelConfigsData
}

export interface GetModelConfigsData {
    modelConfig: ModelConfig
}


export function meterDetail(req: GetMeterDetailReq): Promise<GetMeterRes> {
    return request.post<GetMeterRes>('/api/meter/meter', req);
}

export function meters(req: GetMetersReq): Promise<MeterList> {
    return request.post<MeterList>('/api/meter/meters', req);
}

export function meterTypes(req: MeterTypeReq): Promise<MeterTypeList> {
    return request.post<MeterTypeList>('/api/meter/meterTypes', req);
}

export function childMeters(req: ChildMeterReq): Promise<MeterList> {
    return request.post<MeterList>('/api/meter/getChildMeters', req);
}
export function meterFaults(req: GetMessageReq): Promise<MeterFalutList> {
    return request.post<MeterFalutList>('/api/message/meterFaults', req);
}
export function leakages(req: GetMessageReq): Promise<LeakageList> {
    return request.post<LeakageList>('/api/meter/leakages', req);
}
export function queryMeter(req: QueryMeterReq): Promise<MeterList> {
    return request.post<MeterList>('/api/query/meter', req);
}
export function addMeter(req: Meter): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/addMeter', req);
}
export function updateMeter(req: Meter): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/updateMeter', req);
}
export function deleteMeter(req: DeleteMeterReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/deleteMeter', req);
}
export function setParentMeter(req: SetMeterParentReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/setMeterParent', req);
}

export function batchBindUser(req: BatchBindUserReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/batchBindUser', req);
}

export function batchBindMeterCost(req: BatchBindMeterCostReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/batchBindCost', req);
}

export function sendData(req: SendDataReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/meter/sendData', req);
}

export function datas(req: GetDataReq): Promise<GetDatasRes> {
    return request.post<GetDatasRes>('/api/meter/datas', req);
}

export function datasV2(req: GetDataReq): Promise<GetDatasRes> {
    return request.get<GetDatasRes>('/v2/admin/meter/readings', req);
}

export function externalDeviceDatas(req: GetExternalDeviceDataReq): Promise<GetExternalDeviceDataRes> {
    return request.post<GetExternalDeviceDataRes>('/api/meter/externalDeviceDatas', req);
}


export function getPowerConditionerData(req: GetPowerConditionerDataReq): Promise<GetPowerConditionerDataRes> {
    return request.post<GetPowerConditionerDataRes>('/api/meter/getPowerConditioner', req);
}

export function getModelConfigs(req: GetModelConfigsReq): Promise<GetModelConfigsRes> {
    return request.post<GetModelConfigsRes>('/api/meter/getModelConfigs', req);
}
export function reCalculateUsage(req: ReCalculateUsageReq): Promise<CommonResponse> {
    return request.post<GetModelConfigsRes>('/api/meter/reCalculateUsage', req);
}